import { Theme } from '@nexelem/deprecated-theme';

export const getHeader = (theme: Theme) => {
  const typedTheme = theme as Theme;
  const { getColor } = typedTheme.palette;
  const { common } = typedTheme.client.table;
  return {
    '.MuiDataGrid-columnHeader': {
      backgroundColor: getColor(common.backgroundColor),
      padding: theme.spacing(0, 2),
      '&, &:focus, &:focus-within': {
        outline: 'none',
      },
      '&:hover': {
        '& .MuiDataGrid-columnHeaderTitle, & .MuiDataGrid-sortIcon': {
          color: getColor(common.hoverTextColor),
          backgroundColor: 'transparent',
        },
      },
      '&.MuiDataGrid-columnHeader--sorted': {
        '& .MuiDataGrid-columnHeaderTitle, & .MuiDataGrid-sortIcon': {
          color: getColor(common.activeTextColor),
          '&:hover': {
            backgroundColor: 'transparent',
          },
        },
      },
      '&--withRightBorder.MuiDataGrid-columnHeader--pinnedLeft': {
        borderRight: 'transparent',
      },
      '&--withLeftBorder.MuiDataGrid-columnHeader--pinnedRight': {
        borderLeftColor: 'transparent',
        '> .MuiDataGrid-columnSeparator--resizable': {
          display: 'none',
        },
      },
      '.MuiDataGrid-iconButtonContainer .MuiIconButton-root': {
        outline: 'none',
        '&:focus': {
          outline: 'none',
          backgroundColor: 'transparent',
        },
        '&:focus-within': {
          outline: 'none',
          backgroundColor: 'transparent',
        },
      },
      '.MuiDataGrid-columnHeaderTitle': {
        color: getColor(common.mainTextColor),
        ...theme.typography.titilliumWebSemiBold14,
        letterSpacing: '0.05em',
        overflow: 'visible',
        whiteSpace: 'normal',
        wordBreak: 'break-word',
      },
      '.MuiDataGrid-columnHeaderTitleContainerContent': {
        padding: theme.spacing(0.5),
      },
      '.MuiDataGrid-sortIcon': {
        backgroundColor: 'transparent',
        color: getColor(common.activeTextColor),
        width: theme.spacing(3.5),
        height: theme.spacing(4.5),
      },
      '.MuiDataGrid-columnSeparator': {
        display: 'none',
        '&--resizable': {
          visibility: 'visible',
          display: 'flex',
          justifyContent: 'center',
        },
      },
      '.MuiDataGrid-scrollbarFiller': {
        backgroundColor: getColor(common.backgroundColor),
      },
    },
  };
};
